// License Debugging Utility
// This utility helps diagnose license field issues in track data

export const debugLicenseFields = (tracks, maxTracks = 5) => {
  console.log('=== LICENSE FIELD DEBUGGER ===');
  console.log(`Analyzing ${Math.min(tracks.length, maxTracks)} tracks for license-related fields:`);
  
  tracks.slice(0, maxTracks).forEach((track, index) => {
    console.log(`\n--- Track ${index + 1}: ${track.trackName} ---`);
    
    // Check all possible license-related field names
    const allKeys = Object.keys(track);
    const licenseKeys = allKeys.filter(key => 
      key.toLowerCase().includes('license') || 
      key.toLowerCase().includes('licensed') || 
      key.toLowerCase().includes('expire') ||
      key.toLowerCase().includes('status') ||
      key.toLowerCase().includes('inuse') ||
      key.toLowerCase().includes('available')
    );
    
    console.log('All keys in track:', allKeys.join(', '));
    console.log('License-related keys:', licenseKeys);
    
    // Log values for license-related fields
    licenseKeys.forEach(key => {
      console.log(`  ${key}:`, track[key]);
    });
    
    // Specifically check the expected fields
    console.log('Expected license fields:');
    console.log('  licenseStatus:', track.licenseStatus);
    console.log('  dateExpires:', track.dateExpires);
    
    // Check for common alternative field names
    const alternativeFields = [
      'Licensed', 'licensed', 'LICENSED',
      'License', 'license', 'LICENSE', 
      'isLicensed', 'IsLicensed', 'ISLICENSED',
      'inUse', 'inuse', 'in_use',
      'available', 'Available', 'AVAILABLE',
      'status', 'Status', 'STATUS'
    ];
    
    console.log('Checking alternative field names:');
    alternativeFields.forEach(field => {
      if (track.hasOwnProperty(field)) {
        console.log(`  ${field}:`, track[field]);
      }
    });
    
    // Calculate license status using current logic
    const hasExplicitLicense = track.licenseStatus?.isLicensed && 
                (track.licenseStatus.durationType === 'blanket' || 
                 (track.licenseStatus.expiryDate && track.licenseStatus.expiryDate > Date.now()));
    const hasDateExpires = track.dateExpires && track.dateExpires > Date.now();
    const isLicensed = hasExplicitLicense || hasDateExpires;
    
    console.log('License calculation:');
    console.log('  hasExplicitLicense:', hasExplicitLicense);
    console.log('  hasDateExpires:', hasDateExpires);
    console.log('  Final isLicensed:', isLicensed);
  });
  
  console.log('\n=== END LICENSE FIELD DEBUGGER ===');
};

export const findLicenseFieldInconsistencies = (tracks) => {
  const inconsistencies = [];
  
  tracks.forEach((track, index) => {
    // Current logic
    const hasExplicitLicense = track.licenseStatus?.isLicensed && 
                (track.licenseStatus.durationType === 'blanket' || 
                 (track.licenseStatus.expiryDate && track.licenseStatus.expiryDate > Date.now()));
    const hasDateExpires = track.dateExpires && track.dateExpires > Date.now();
    const currentLogicResult = hasExplicitLicense || hasDateExpires;
    
    // Check for alternative fields that might contradict current logic
    const alternativeResults = {};
    
    if (track.Licensed !== undefined) {
      alternativeResults.Licensed = !!track.Licensed;
    }
    if (track.licensed !== undefined) {
      alternativeResults.licensed = !!track.licensed;
    }
    if (track.License !== undefined) {
      alternativeResults.License = !!track.License;
    }
    if (track.license !== undefined) {
      alternativeResults.license = !!track.license;
    }
    if (track.inUse !== undefined) {
      alternativeResults.inUse = !!track.inUse;
    }
    if (track.available !== undefined) {
      alternativeResults.available = !track.available; // inverted logic
    }
    
    // Find inconsistencies
    Object.entries(alternativeResults).forEach(([field, value]) => {
      if (value !== currentLogicResult) {
        inconsistencies.push({
          trackIndex: index,
          trackName: track.trackName,
          currentLogic: currentLogicResult,
          alternativeField: field,
          alternativeValue: value,
          rawFieldValue: track[field]
        });
      }
    });
  });
  
  return inconsistencies;
};